export function parseCriteria(cr: any): string {
  try {
    let criteriaData = JSON.parse(cr.criteria);
    if ("displayShort" in criteriaData) {
      return criteriaData.displayShort.replace(/\.$/, "");
    } else if ("display_short" in criteriaData) {
      return criteriaData.display_short.replace(/\.$/, "");
    } else {
      return cr.criteria.replace(/\.$/, "");
    }
  } catch {
    return cr.criteria.replace(/\.$/, "");
  }
}

export function sortByCriteriaMatch(criteriaArr: any[]) {
  return [...criteriaArr].sort((a, b) => (b.isMatch === "match" ? 1 : a.isMatch === "match" ? -1 : 0));
}
